import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';

import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/symptoms/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/symptoms/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/symptoms/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadSymptoms() {
  return {
    [RSAA]: {
      ...api.getSymptoms(),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: [],
};

export default function symptomsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}
